import { createFeatureSelector, createSelector } from '@ngrx/store';
import { mobilityManagerFeatureKey, MobilityManagerState } from './mobility-manager.reducer';
import { PaymentUtil } from '@uzurv/clara';

export const selectMobilityManagerState = createFeatureSelector<MobilityManagerState>(mobilityManagerFeatureKey);

export const getOrganizationPaymentAccounts = createSelector(selectMobilityManagerState, state =>
  [...state.organizationPaymentAccounts].sort((a, b) => {
    if (a.default !== b.default) {
      return a.default ? -1 : 1;
    }
    return b.createdDate.getTime() - a.createdDate.getTime();
  })
);

export const getOrganizationPaymentAccountDefault = createSelector(selectMobilityManagerState, state =>
  state.organizationPaymentAccounts.find(account => account.default)
);

export const getSubmittingPaymentAccount = createSelector(selectMobilityManagerState, state => state.isSubmitting);

export const isOrganizationPaymentAccountDefaultExpired = createSelector(selectMobilityManagerState, state => {
  return PaymentUtil.isDefaultOrganizationPaymentAccountExpired(state.organizationPaymentAccounts);
});

export const hasOrganizationPaymentAccounts = createSelector(
  selectMobilityManagerState,
  state => state.organizationPaymentAccounts.length > 0
);

export const hasOpenedNoPaymentAccountsDialog = createSelector(selectMobilityManagerState, state => state.hasOpenedNoPaymentAccountsDialog);

export const hasOpenedExpiredPaymentAccountsDialog = createSelector(
  selectMobilityManagerState,
  state => state.hasOpenedExpiredPaymentAccountsDialog
);
